import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { customEnumConverterMap } from './customEnumPropsToCss'

/**
 * Enriches the converters registry with all CustomEnum style property converters.
 * CustomEnum converters handle custom enumerated values that are validated against manifest schemas.
 */
export function enrichCustomEnumConverters(): void {
	// Register all custom enum converters
	Object.entries(customEnumConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
